export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11667.dd18e9bf.jpg";